import {
    RECORDING_TYPE_AI_CALL,
    RECORDING_TYPE_CALL,
    RECORDING_TYPE_VOICE_MAIL,
    RECORDING_TYPE_HANGED_UP,
    RECORDING_TYPE_APPOINTMENT_CONFIRMATION,
    RECORDING_TYPE_DISINTERESTED_CUSTOMER,
} from 'src/constants/recordings';
import { IRecordingsType } from 'src/interfaces/recordings';

/**
 * Returns the color of the label based on the recording call type
 *
 * @param {string} type - The type to get the color for
 * @return {*}  {string}
 */
export const getRecordingTypeLabelColor = (type: IRecordingsType): string => {
    if (type === RECORDING_TYPE_AI_CALL) return 'pink';
    if (type === RECORDING_TYPE_CALL) return 'cyan';
    if (type === RECORDING_TYPE_VOICE_MAIL) return 'deepOrange';
    if (type === RECORDING_TYPE_HANGED_UP) return 'lightGrey';
    if (type === RECORDING_TYPE_APPOINTMENT_CONFIRMATION) return 'darkTeal';
    if (type === RECORDING_TYPE_DISINTERESTED_CUSTOMER) return 'lowRed';

    return 'primary';
};
